<template>
<div class="card">
    <div class="card-header">RDC Onboard</div>
    <div class="card-body">
        <form-summary :validator="$v" ref="errorContainer" id="errorContainer"/>

        <b-form @submit.stop.prevent="onSubmit">
            <b-row>
                <b-col>
                    <LifecycleCheckList lifecycleStatus="20"
                        v-on:checklist-update="updateChecklistStatus($event)" ref="checklist"/>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <BaseParagraphInput v-model="comments"
                        :v="$v.comments" 
                        slug="rdcComments"
                        label="Internal Comments"/>
                </b-col>
            </b-row>
            
            <div>
                <b-button type="submit" variant="primary">Complete RDC Onboard</b-button>
                <b-button type="button" variant="outline primary" @click="save">Save</b-button>
            </div>
        </b-form>
    </div>
</div>

</template>

<script>
import axios from "axios"
import { required, email, minLength, maxLength, numeric } from 'vuelidate/lib/validators'
import LifecycleCheckList from '@/components/lifecycles/LifecycleCheckList'

export default {
    components: {
        LifecycleCheckList,
    },
    props: {
        request: Object
    },
    data() {
        return { 
            checklistComplete: false,
            comments: '',
            saveOnly: false,
        }
    },
     validations: {
         comments: { required: false, maxLength: maxLength(4000) },
         checklistComplete: { checked: value => value === true },
         request: { 
         }
     },
    methods: {
        updateChecklistStatus(b) {
            this.checklistComplete = b
        },

        save() {
            this.saveOnly = true
            this.onSubmit()
            this.saveOnly = false
        },

        onSubmit() {
            if (!this.saveOnly) {
                this.$refs.checklist.emitCheckListStatus()
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$nextTick(() => {
                        document.getElementById('form-container').scrollIntoView()
                    })
                    return
                }
            }

            let payload = {
                requestId: this.request.id,
                comments: this.comments,
                advanceNextLifecycle: !this.saveOnly
            }

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/rdcOnboard`, payload)
                .then(response => {                       
                this.showRootToast("RDC Onboarding Submitted", "updated.", "success")
                this.$emit('status-changed') 
                })                  
        },

        showRootToast(title, message, type) {
            this.$root.$bvToast.toast(message, {
                  title: title,
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: type,
                  appendToast: true
                })
        },
    }   
}
</script>